import { lazy } from 'react'

export function lazyWithRetry(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  componentImport: () => Promise<{ default: React.ComponentType<any> }>
) {
  return lazy(async () => {
    const storageKey = 'chunk-retry-refreshed'
    const hasBeenRefreshed = JSON.parse(
      window.sessionStorage.getItem(storageKey) || 'false'
    )

    try {
      const component = await componentImport()
      window.sessionStorage.setItem(storageKey, 'false')
      return component
    } catch (error) {
      if (!hasBeenRefreshed) {
        window.sessionStorage.setItem(storageKey, 'true')
        window.location.reload()
        return { default: () => null as unknown as React.ReactElement }
      }
      // Already retried once — let ErrorBoundary handle it
      throw error
    }
  })
}
